import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from "@/components/ui/sonner"
import { MotionConfig } from "framer-motion"
import { useIsMobile } from "@/utils"

function App() {
  const isMobile = useIsMobile();
  
  // Mobile-optimized motion settings for smoother performance
  const motionSettings = isMobile ? {
    transition: { 
      duration: 0.3, // Reduced from typical 0.5s for faster mobile animations
      ease: "easeOut" // Simpler easing for better mobile performance
    }
  } : {
    transition: { 
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1] // Custom easing for desktop
    }
  };
  
  return (
    <MotionConfig {...motionSettings}>
      <Pages />
      <Toaster />
    </MotionConfig>
  )
}

export default App 